import { provideWidgetClass } from 'scrivito'

export const DXPSidebarLeftWidget = provideWidgetClass(
  'DXPSidebarLeftWidget',
  {},
)
